import { Injectable } from '@angular/core';
import { Headers, Http, Response, RequestOptions, ResponseContentType } from '@angular/http';
import { Subscription } from '../Classes/SubscriptionClass';
import { CommonSearch } from '../Classes/CommonClass';
import 'rxjs/add/operator/map';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SubscriptionServiceDto } from '../Classes/SubscriptionServiceDto';

@Injectable()
export class SubscriptionService {
  constructor(private http: Http) { }
  SaveSubscriptionDetails(_Suscription: Subscription) {
    
    let body: string = JSON.stringify(_Suscription);
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let options: RequestOptions = new RequestOptions({ headers: headers });
    return this.http.post('api/Subscription/SaveSubscriptionDetails', body, options)
      .map((res: Response) => res.json());
  }

  postFile(fileToUpload: File): Observable<boolean> {
    const endpoint = 'your-destination-url';
    const formData: FormData = new FormData();
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    formData.append('fileKey', fileToUpload, fileToUpload.name);
    return this.http
      .post(endpoint, formData, { headers: headers })
      .map(() => { return true; });
  }

  GetSubscriptionchangeLog(SubscriptionId: string) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let body = { "SubscriptionId": JSON.stringify(SubscriptionId) };
    let options: RequestOptions = new RequestOptions({ headers: headers, params: body });
    return this.http.get('api/Subscription/GetSubscriptionchangeLog', options)
      .map((res: Response) => res.json());
  }


  GetSubSearchResult(Tenantid: string, EntityId: string) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let SubsDetails = { "Tenantid": JSON.stringify(Tenantid), "HotelId": JSON.stringify(EntityId) };
    let options: RequestOptions = new RequestOptions({ headers: headers, params: SubsDetails });
    return this.http.get('api/Subscription/GetSubsSearchResult', options)
      .map((res: Response) => res.json());

  }
  GetEPayAccount(Tenantid: string, EntityId: string) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let SubsDetails = { "Tenantid": JSON.stringify(Tenantid), "HotelId": JSON.stringify(EntityId) };
    let options: RequestOptions = new RequestOptions({ headers: headers, params: SubsDetails });
    return this.http.get('api/Subscription/GetAccountDetailsForEntity', options)
      .map((res: Response) => res.json());

  }
  SaveEPayAccount(Tenantid: string, EntityId: string, EpayCustId: string, OprId: string) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let SubsDetails = { "Tenantid": JSON.stringify(Tenantid), "HotelId": JSON.stringify(EntityId), "EpayCustId": JSON.stringify(EpayCustId), "OprId": JSON.stringify(OprId) };
    let options: RequestOptions = new RequestOptions({ headers: headers, params: SubsDetails });
    return this.http.get('api/Subscription/SaveEPayCustomerId', options)
      .map((res: Response) => res.json());
  }

  SaveDualPMSSetting(Tenantid: string, EntityId: string, PMSMaster: string, PMSName: string, isDualPMS : string) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let SubsDetails = { "Tenantid": JSON.stringify(Tenantid), "HotelId": JSON.stringify(EntityId), "PMSMaster": JSON.stringify(PMSMaster), "PMSName": JSON.stringify(PMSName), "isDualPMS": JSON.stringify(isDualPMS) };
    let options: RequestOptions = new RequestOptions({ headers: headers, params: SubsDetails });
    return this.http.get('api/Subscription/SaveDualPMSSetting', options)
      .map((res: Response) => res.json());

  }
  GetDaautoImport(Tenantid: string, EntityId: string) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let SubsDetails = { "Tenantid": JSON.stringify(Tenantid), "HotelId": JSON.stringify(EntityId) };
    let options: RequestOptions = new RequestOptions({ headers: headers, params: SubsDetails });
    return this.http.get('api/Subscription/GetDaautoImport', options)
      .map((res: Response) => res.json());

  }
   //Below Code not user
  GetLatestSubsDate(SubscriptionID: string, Tenantid: string, EntityId: string) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let SubsDetails = { "Tenantid": JSON.stringify(Tenantid), "HotelId": JSON.stringify(EntityId), "SubscriptionID": JSON.stringify(SubscriptionID)};
    let options: RequestOptions = new RequestOptions({ headers: headers, params: SubsDetails });
    return this.http.get('api/Subscription/GetSubscriptionStartDate', options)
      .map((res: Response) => res.json());
  }



  GetCompareDate(Tenantid: string, EntityId: string) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let SubsDetails = { "Tenantid": JSON.stringify(Tenantid), "HotelId": JSON.stringify(EntityId) };
    let options: RequestOptions = new RequestOptions({ headers: headers, params: SubsDetails });
    return this.http.get('api/Subscription/GetCompareDate', options)
      .map((res: Response) => res.json());

  }

  CheckPayrollHid(EntityId: string, Type: string, Tenantid: string) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let payrollChk = {
      "Hid": JSON.stringify(EntityId), "Type": JSON.stringify(Type), "Tenantid": JSON.stringify(Tenantid)
    };
    let options: RequestOptions = new RequestOptions({ headers: headers, params: payrollChk });
    return this.http.get('api/Subscription/CheckPayrollHid', options)
      .map((res: Response) => res.json());
  }

  GetEditSubSearchResult(Tenantid: string, EntityId: string,Module:string,type:string) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let SubsDetails = { "Tenantid": JSON.stringify(Tenantid), "HotelId": JSON.stringify(EntityId), "Module": JSON.stringify(Module),"type":JSON.stringify(type)};
    let options: RequestOptions = new RequestOptions({ headers: headers, params: SubsDetails });
    return this.http.get('api/Subscription/GetEditSubsSearchResult', options)
      .map((res: Response) => res.json());
  }
  SaveSubscriptions(_Suscription: Subscription) {
    let body: string = JSON.stringify(_Suscription);
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let options: RequestOptions = new RequestOptions({ headers: headers });
    return this.http.post('api/Subscription/SaveSubscriptions', body, options)
      .map((res: Response) => res.json());
  }

  /************Subscription Search****/
  GetSubscriptionAutoCompleteResult(_CommonSearch: CommonSearch) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let ParmDetails = { "Searchstring": JSON.stringify(_CommonSearch.Searchstring), "SearchType": JSON.stringify(_CommonSearch.SearchType) };
    let options: RequestOptions = new RequestOptions({ headers: headers, params: ParmDetails });
    return this.http.get('api/Subscription/GetAutoCompleteResult', options)
      .map((res: Response) => res.json());
  }

  GetSubscriptionSearchResult(_CommonSearch: CommonSearch) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let OrgDetails = { "SearchQuery": JSON.stringify(_CommonSearch.SearchQuery) };
    let options: RequestOptions = new RequestOptions({ headers: headers, params: OrgDetails });
    return this.http.get('api/Subscription/GetSubscriptionSearchResult', options)
      .map((res: Response) => res.json());
  }

  GetSubscriptionExportTemplate(SubscriptionId: string,fileName:string) {
    //let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let Subscription = { "SubscriptionId": JSON.stringify(SubscriptionId), "FileName": JSON.stringify(fileName)};
    let options = new RequestOptions({ responseType: ResponseContentType.Blob, params: Subscription });
    return this.http.get('api/Subscription/GetSubscriptionExportTemplate', options)
      .map(res => res)

  }

  DeleteFile(SubscriptionId: string) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let ParmDetails = { "SubscriptionId": JSON.stringify(SubscriptionId)};
    let options: RequestOptions = new RequestOptions({ headers: headers, params: ParmDetails });
    return this.http.get('api/Subscription/DeleteFile', options)
      .map((res: Response) => res.json());
  }


  GetMachineIDDetail(Tenantid: string, EntityId: string) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let SubsDetails = { "Tenantid": JSON.stringify(Tenantid), "HotelId": JSON.stringify(EntityId) };
    let options: RequestOptions = new RequestOptions({ headers: headers, params: SubsDetails });
    return this.http.get('api/Subscription/GetLaborTimeClockDeviceDetails', options)
      .map((res: Response) => res.json());
  }

  EnableDisableMachineIDDetail(uniqueNo: number, EnableDisable: string) {
    //
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let SubsDetails = { "uniqueNo": JSON.stringify(uniqueNo), "EnableDisable": JSON.stringify(EnableDisable) };
    let options: RequestOptions = new RequestOptions({ headers: headers, params: SubsDetails });
    return this.http.get('api/Subscription/EnableDisableMachineIDDetail', options)
      .map((res: Response) => res.text());  //.map((res: Response) => res.toString());
  }
    
      
  

  DeleteMachineIDDetail(uniqueNo: number) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let SubsDetails = { "uniqueNo": JSON.stringify(uniqueNo) };
    let options: RequestOptions = new RequestOptions({ headers: headers, params: SubsDetails });
    return this.http.get('api/Subscription/DeleteMachineIDDetail', options)
      .map((res: Response) => res.toString());
  }

  SaveLaborTimeClockDeviceDetails(
    HotelId: string, TenantId: string, UserName: string, uniqueNo: string,
    machinId: string, defaultLanguage: string, notes: string) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let SubsDetails = {
      "Hid": JSON.stringify(HotelId), "Tenantid": JSON.stringify(TenantId), "UserName": JSON.stringify(UserName),
      "UniqueNo": JSON.stringify(uniqueNo), "machinId": JSON.stringify(machinId),
      "defaultLanguage": JSON.stringify(defaultLanguage), "notes": JSON.stringify(notes)
    };
    let options: RequestOptions = new RequestOptions({ headers: headers, params: SubsDetails });
    return this.http.get('api/Subscription/SaveLaborTimeClockDeviceDetails', options)
      .map((res: Response) => res.text());
      //.map((res: Response) => res.toString());
  }


  GetSubscriptionServices(subscriptionModuleName: string, hid: number, tenantId: number) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let SubsDetails = { "subscriptionModuleName": subscriptionModuleName, "hid": JSON.stringify(hid), "tenantId": JSON.stringify(tenantId) };
    let options: RequestOptions = new RequestOptions({ headers: headers, params: SubsDetails });
    return this.http.get('api/Subscription/GetSubscriptionServices', options)
      .map((res: Response) => res.json());
  }
  AddUpdateSubscriptionServicesMapping(subscriptionService: SubscriptionServiceDto) {
    let body: string = JSON.stringify(subscriptionService);
    debugger;
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let options: RequestOptions = new RequestOptions({ headers: headers });
    return this.http.post('api/Subscription/AddUpdateSubscriptionServicesMapping', body, options)
      .map((res: Response) => res.json());
  }

  DeleteSubscriptionServicesMapping(id: number) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let params = { "id": JSON.stringify(id) };
    let options: RequestOptions = new RequestOptions({ headers: headers, params: params });
    return this.http.delete('api/Subscription/DeleteSubscriptionServicesMapping', options)
      .map((res: Response) => res.json());
  }
  /************Subscription Search****/
}



// WEBPACK FOOTER //
// ./src/app/Services/SubscriptionService.ts